module.exports = __webpack_public_path__ + "static/img/send.48c3d8e9.png";